export class ActivosModel {
    departamentos?: any[];
    response?: any;
    tipos_activos?: any[];
    total_pages?: number;
}